export default __webpack_public_path__ + "static/media/DinosaursArmoredReptiles_02.90cba935.png";